var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('div',{staticClass:"logo ma-6 ma-md-8 ma-lg-10 ma-xl-12"},[_c('AppLogo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }